<ng-container *ngIf="address?.companyName">
    {{ address.companyName }},
</ng-container>
{{ address?.firstName }} {{ address?.lastName }},
{{ address?.street}}, {{ address?.houseNumber }},
<ng-container *ngIf="address?.addressLine2">
    {{ address.addressLine2 }},
</ng-container>
{{ address?.postalCode}} {{ address?.city }},
<ng-container *ngIf="address?.stateOrProvince">
  {{ address.stateOrProvince }},
</ng-container>
{{ address?.country?.title }}
